export default __webpack_public_path__ + "static/media/ron-rotter.dacc771b.png";